export const authRoutesConstants = {
  root: {
    path: "/r/auth",
    href: () => "/r/auth"
  },
  login: {
    path: "/r/auth/login",
    href: (redirect_url?: string) =>
      `/r/auth/login${redirect_url ? `?referrer=${redirect_url}` : ""}`
  },
  signup: {
    path: "/r/auth/signup",
    href: (token?: string) => `/r/auth/signup?token=${token}`
  },
  forgotPassword: {
    path: "/r/auth/forgot-password",
    href: () => "/r/auth/forgot-password"
  },
  resetPassword: {
    path: "/r/auth/reset-password",
    href: (token: string) => `/r/auth/reset-password?token=${token}`
  }
} as const;
